import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styles from '../../../../css/devicePage.module.css'
import colors from '../../../../css/colors.module.css'
import { SpeedometerOff } from '../Graphics/Speedometer'
import FuelNotConnected from '../Graphics/FuelNotConnected'

/**
 * Horizontal line component.
 * @param {{color: {string}, isDashed: {boolean }}} props
 */
const HLine = ({ color, isDashed }) => {
  const lineStyle = isDashed ? 'dashed' : 'solid'
  const style = {
    border: `3px ${lineStyle} ${color}`,
    width: '90%',
    margin: 'auto',
    marginTop: '5%',
    marginBottom: '5%',
  }
  return <hr style={style} />
}
HLine.propTypes = {
  color: PropTypes.string,
  isDashed: PropTypes.bool,
}

export const IconLink = (props) => {
  const {
    path,
    label,
    value,
    unit = '',
    width,
    color,
    line,
    dashed,
    control,
    name,
    disabled,
    icon,
    external = false,
    iconOnly = false,
  } = props

  let returnValue
  if (value && typeof value === 'object' && value.props) {
    returnValue = value
  } else if (iconOnly) {
    returnValue = (
      <div className={styles.tileIconOnly}>
        {icon || null}
      </div>
    )
  } else {
    returnValue = (
      <h2 className={styles.tileValue}>{`${value}${unit}`}</h2>
    )
  }
  let colorValue = colors.normal
  if (color) {
    colorValue = color
  }
  let buttonStyle = styles.tileButton
  if (width && width === 'triple') {
    buttonStyle = styles.tileButtonTriple
  }
  let styleDirect
  if (control) {
    styleDirect = { boxShadow: '1px 1px 5px 1px rgb(0,0,0,0.50)' }
  }

  if (external) {
    return (
      <a href={path} target='_blank' rel='noopener noreferrer'>
        <button
          type='button'
          className={`${buttonStyle} ${colorValue}`}
          style={styleDirect}
          name={name}
          disabled={disabled}
        >
          <div className={styles.tile}>
            {returnValue}
            {iconOnly ? null : (icon || null)}
            <h6>{label}</h6>
            {line && <HLine color={line} isDashed={dashed} />}
          </div>
        </button>
      </a>
    )
  }
  return (
    <Link to={disabled ? '' : path}>
      <button
        type='button'
        className={`${buttonStyle} ${colorValue}`}
        style={styleDirect}
        name={name}
        disabled={disabled}
      >
        <div className={styles.tile}>
          {returnValue}
          <h6>{label}</h6>
          {line && <HLine color={line} isDashed={dashed} />}
        </div>
      </button>
    </Link>
  )
}
IconLink.propTypes = {
  color: PropTypes.string,
  dashed: PropTypes.string,
  path: PropTypes.string,
  label: PropTypes.string,
  line: PropTypes.string,
  value: PropTypes.node,
  unit: PropTypes.string,
  width: PropTypes.string,
}

export const CellBars = (props) => {
  const {
    path,
    label,
    signalStrength,
    unit = '',
    width,
    line,
    dashed,
    control,
    name,
  } = props

  const colorValue = '#284047'

  let buttonStyle = styles.tileButton
  if (width && width === 'triple') {
    buttonStyle = styles.tileButtonTriple
  }
  let styleDirect
  if (control) {
    styleDirect = { boxShadow: '1px 1px 5px 1px rgb(0,0,0,0.50)' }
  }
  const labelStyle = {
    color: colorValue,
  }
  let barsSvg
  if (signalStrength === 5) {
    barsSvg = (
      <svg
        width='63'
        height='65'
        viewBox='0 0 63 65'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect x='0.8' y='43.7' width='11.2' height='21.1' fill={colorValue} />
        <rect x='16.3' y='28.3' width='12.7' height='36.6' fill={colorValue} />
        <rect x='33.1' y='14.2' width='12.7' height='50.7' fill={colorValue} />
        <rect x='50.1' y='0.13' width='12.7' height='64.8' fill={colorValue} />
      </svg>
    )
  } else if (signalStrength === 4) {
    barsSvg = (
      <svg
        width='63'
        height='65'
        viewBox='0 0 63 65'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect x='0.8' y='43.7' width='11.2' height='21.1' fill={colorValue} />
        <rect x='16.3' y='28.3' width='12.7' height='36.6' fill={colorValue} />
        <rect x='33.1' y='14.2' width='12.7' height='50.7' fill={colorValue} />
        <rect
          x='50.1'
          y='0.13'
          width='12.7'
          height='64.8'
          stroke={colorValue}
          strokeWidth='2'
        />
      </svg>
    )
  } else if (signalStrength === 3) {
    barsSvg = (
      <svg
        width='63'
        height='65'
        viewBox='0 0 63 65'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect x='0.8' y='43.7' width='11.2' height='21.1' fill={colorValue} />
        <rect x='16.3' y='28.3' width='12.7' height='36.6' fill={colorValue} />
        <rect
          x='33.1'
          y='14.2'
          width='12.7'
          height='50.7'
          stroke={colorValue}
          strokeWidth='2'
        />
        <rect
          x='50.1'
          y='0.13'
          width='12.7'
          height='64.8'
          stroke={colorValue}
          strokeWidth='2'
        />
      </svg>
    )
  } else if (signalStrength === 2) {
    barsSvg = (
      <svg
        width='63'
        height='65'
        viewBox='0 0 63 65'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect x='0.8' y='43.7' width='11.2' height='21.1' fill={colorValue} />
        <rect
          x='16.3'
          y='28.3'
          width='12.7'
          height='36.6'
          stroke={colorValue}
          strokeWidth='2'
        />
        <rect
          x='33.1'
          y='14.2'
          width='12.7'
          height='50.7'
          stroke={colorValue}
          strokeWidth='2'
        />
        <rect
          x='50.1'
          y='0.13'
          width='12.7'
          height='64.8'
          stroke={colorValue}
          strokeWidth='2'
        />
      </svg>
    )
  } else if (signalStrength === -1) {
    barsSvg = (
      <svg
        width='63'
        height='66'
        viewBox='0 0 63 66'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          x='2'
          y='45.0146'
          width='9.2674'
          height='19.1264'
          stroke='#284047'
          strokeWidth='2'
        />
        <rect
          x='17.4927'
          y='29.522'
          width='10.6758'
          height='34.6191'
          stroke='#284047'
          strokeWidth='2'
        />
        <rect
          x='34.3938'
          y='15.4377'
          width='10.6758'
          height='48.7033'
          stroke='#284047'
          strokeWidth='2'
        />
        <rect
          x='51.2947'
          y='1.35352'
          width='10.6758'
          height='62.7876'
          stroke='#284047'
          strokeWidth='2'
        />
        <path
          d='M7.83932 5.83133C7.83932 4.50602 7.02836 3.71084 5.67675 3.71084C4.32514 3.71084 3.51418 4.50602 2.70321 5.3012L0 2.91566C1.62193 1.06024 3.7845 0 6.21739 0C9.73157 0 12.4348 1.59036 12.4348 5.56626C12.4348 9.54217 7.569 10.6024 7.83932 14.3133H3.7845C2.97354 10.0723 7.83932 8.21687 7.83932 5.83133ZM2.97354 19.0843C2.97354 17.494 4.32514 16.1687 5.94707 16.1687C7.569 16.1687 8.9206 17.494 8.9206 19.0843C8.9206 20.6747 7.569 22 5.94707 22C4.05482 22 2.97354 20.6747 2.97354 19.0843Z'
          fill='#284047'
        />
      </svg>
    )
  } else {
    barsSvg = (
      <svg
        width='69'
        height='69'
        viewBox='0 0 69 69'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M64 34.5C64 50.7924 50.7924 64 34.5 64C28.2788 64 22.5073 62.0742 17.7492 58.7862L58.7862 17.7492C62.0742 22.5073 64 28.2788 64 34.5ZM55.5906 13.8738L13.8738 55.5906C8.39834 50.2349 5 42.7643 5 34.5C5 18.2076 18.2076 5 34.5 5C42.7643 5 50.2349 8.39834 55.5906 13.8738ZM69 34.5C69 53.5538 53.5538 69 34.5 69C15.4462 69 0 53.5538 0 34.5C0 15.4462 15.4462 0 34.5 0C53.5538 0 69 15.4462 69 34.5Z'
          fill={colorValue}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M33 26L21 14H33H37H49L37 26V59H33V26ZM37 16V23L44 16H37ZM33 23V16H26L33 23Z'
          fill={colorValue}
        />
      </svg>
    )
  }
  return (
    <Link to={path}>
      <button
        type='button'
        className={`${buttonStyle}`}
        style={styleDirect}
        name={name}
      >
        <div className={styles.tile}>
          {barsSvg}
          <h6 style={labelStyle}>{label}</h6>
          {line && <HLine color={line} isDashed={dashed} />}
        </div>
      </button>
    </Link>
  )
}
CellBars.propTypes = {
  color: PropTypes.string,
  dashed: PropTypes.string,
  path: PropTypes.string,
  label: PropTypes.string,
  line: PropTypes.string,
  value: PropTypes.node,
  unit: PropTypes.string,
  width: PropTypes.string,
}

export const IconError = ({ type, label, path, name }) => {
  let displayValue
  switch (type) {
    case 'temperature':
      displayValue = (
        <div className={styles.tile}>
          <div className={styles.valueInfo} name={name}>
            <span className='fa fa-thermometer-empty fa-3x' />
          </div>
          <h6>{label}</h6>
        </div>
      )
      break
    case 'pressure':
      displayValue = (
        <div className={styles.tile}>
          <div className={styles.valueInfo} name={name}>
            <SpeedometerOff color='inherit' />
          </div>
          <h6>{label}</h6>
        </div>
      )
      break
    case 'fuelLevelNotConnected':
      displayValue = (
        <div className={styles.tile}>
          <div className={styles.valueInfo} name={name}>
            <FuelNotConnected color='#D00000' />
          </div>
          <h6>{label}</h6>
        </div>
      )
      break
    default:
      displayValue = (
        <div className={styles.tile}>
          <h2 className={styles.tileValue}>ERROR</h2>
          <h6>{label}</h6>
        </div>
      )
  }
  return (
    <Link to={path}>
      <button
        type='button'
        className={`${styles.tileButton} ${styles.tileButtonError}`}
        name={name}
      >
        {displayValue}
      </button>
    </Link>
  )
}
IconError.propTypes = {
  path: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
}

export const TextLink = ({ text, path, className }) => {
  return (
    <Link to={path}>
      <button
        type='button'
        className={`${styles.interfaceButton} ${className}`}
      >
        <h3>{text}</h3>
      </button>
    </Link>
  )
}
TextLink.propTypes = {
  path: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.array,
  ]),
}

export const SimpleLink = ({
  path,
  label,
  value,
  unit,
  enable,
  userStyle,
  userValueStyle,
}) => {
  let valueClass = styles.simpleLinkValue
  if (enable) {
    valueClass = styles.simpleLinkValueEdit
  }
  if (enable && userValueStyle) {
    valueClass = styles.simpleLinkValueEdit
  }

  let actualStyle = styles.simpleLink
  if (userStyle) {
    actualStyle = userStyle
  }
  return (
    <Link to={enable ? path : null}>
      <section className={actualStyle}>
        <h5>{label}</h5>
        <div className={valueClass}>
          {value} {unit}
        </div>
      </section>
    </Link>
  )
}

SimpleLink.propTypes = {
  path: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.array,
  ]),
  value: PropTypes.node,
  unit: PropTypes.string,
  enable: PropTypes.bool,
  userStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
}

export const CapitalButton = ({
  text,
  buttonFunction,
  hSize,
  style,
  disabled,
  buttonStyles,
}) => {
  let textReturn = <h1>{text}</h1>
  if (hSize) {
    switch (hSize) {
      case 'h1':
        textReturn = <h1>{text}</h1>
        break
      case 'h2':
        textReturn = <h2>{text}</h2>
        break
      case 'h3':
        textReturn = <h3>{text}</h3>
        break
      case 'h4':
        textReturn = <h4>{text}</h4>
        break
      case 'h5':
        textReturn = <h5>{text}</h5>
        break
      default:
        textReturn = <h4>{text}</h4>
        break
    }
  }
  return (
    <button
      className={`${styles.capitalButton} ${style}`}
      onClick={buttonFunction}
      styles={buttonStyles}
      disabled={disabled}
    >
      {textReturn}
    </button>
  )
}

CapitalButton.propTypes = {
  text: PropTypes.string,
  style: PropTypes.string,
  hSize: PropTypes.string,
  buttonFunction: PropTypes.func,
  disabled: PropTypes.bool,
  buttonStyles: PropTypes.object,
}
